import JsBarcode from 'jsbarcode'

function escapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

function formatQuantity(value) {
  const num = Number(value)
  if (Number.isNaN(num)) return ''
  return num.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

function formatDate(value) {
  if (!value) return ''
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  return date.toLocaleString('es-MX', { dateStyle: 'medium', timeStyle: 'short' })
}

function barcodeMarkup(code) {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  document.body.appendChild(svg)
  try {
    JsBarcode(svg, code, {
      format: 'CODE128',
      width: 2,
      height: 72,
      displayValue: true,
      fontSize: 16,
      margin: 0,
    })
    return svg.outerHTML
  } finally {
    svg.remove()
  }
}

export function printRequisition(requisition) {
  if (!requisition) return
  const code = requisition.barcode || requisition.requisition_number
  const printWindow = window.open('', '_blank', 'width=800,height=900')
  if (!printWindow) return

  const rows = (requisition.items || []).map((item) => `
    <tr>
      <td>${escapeHtml(item.part_barcode)}</td>
      <td>${escapeHtml(item.part_name)}</td>
      <td class="qty">${escapeHtml(formatQuantity(item.quantity))}</td>
      <td>${escapeHtml(item.part_unit_of_measure || '')}</td>
    </tr>
  `).join('')

  const printScript = '<scr' + 'ipt>window.onload = function () { window.print(); }</scr' + 'ipt>'
  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8" />
        <title>Requisición ${escapeHtml(requisition.requisition_number)}</title>
        <style>
          body { font-family: Arial, sans-serif; color: #111; margin: 24px; }
          h1 { font-size: 20px; margin: 0 0 4px; letter-spacing: 0.04em; }
          .subtitle { margin: 0 0 16px; color: #444; font-size: 13px; }
          .barcode { margin: 8px 0 16px; }
          .meta { display: grid; grid-template-columns: 1fr 1fr; gap: 6px 24px; font-size: 13px; margin-bottom: 16px; }
          .meta strong { display: inline-block; min-width: 88px; }
          table { width: 100%; border-collapse: collapse; font-size: 13px; }
          th, td { border: 1px solid #222; padding: 6px 8px; text-align: left; }
          th { background: #f3f3f3; }
          td.qty, th.qty { text-align: right; }
          .comments { margin-top: 14px; font-size: 13px; }
          .signs { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 28px; margin-top: 56px; }
          .sign { border-top: 1px solid #222; padding-top: 6px; text-align: center; font-size: 12px; }
          .hint { margin-top: 28px; font-size: 12px; color: #333; }
        </style>
      </head>
      <body>
        <h1>REQUISICIÓN DE ALMACÉN</h1>
        <p class="subtitle">Solicitud de piezas para taller</p>
        <div class="barcode">${barcodeMarkup(code)}</div>
        <div class="meta">
          <div><strong>Folio:</strong> ${escapeHtml(requisition.requisition_number)}</div>
          <div><strong>Fecha:</strong> ${escapeHtml(formatDate(requisition.created_at))}</div>
          <div><strong>Elaboró:</strong> ${escapeHtml(requisition.created_by_name || '')}</div>
          <div><strong>Orden:</strong> ${escapeHtml(requisition.maintenance_order_number || '')}</div>
          <div><strong>Unidad:</strong> ${escapeHtml(requisition.unit_short_id || '')}</div>
          <div><strong>Estatus:</strong> ${escapeHtml(requisition.status_label || '')}</div>
        </div>
        <table>
          <thead>
            <tr>
              <th>Código</th>
              <th>Pieza</th>
              <th class="qty">Cantidad</th>
              <th>Unidad</th>
            </tr>
          </thead>
          <tbody>
            ${rows || '<tr><td colspan="4">Sin piezas</td></tr>'}
          </tbody>
        </table>
        ${requisition.comments ? `<p class="comments"><strong>Comentarios:</strong> ${escapeHtml(requisition.comments)}</p>` : ''}
        <div class="signs">
          <div class="sign">Solicita</div>
          <div class="sign">Autoriza</div>
          <div class="sign">Entrega almacén</div>
        </div>
        <p class="hint">Presente esta requisición en almacén, o indique el folio para que sea escaneado.</p>
        ${printScript}
      </body>
    </html>
  `)
  printWindow.document.close()
}
